import { NgModule } from "@angular/core";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ThemeModule } from "./theme/theme.module";
import { AuthenticationService } from "./services/authentication.service";
import { FormsModule } from "@angular/forms";
import { LoggerService } from "./core/logger.service";
import { TokenInterceptor } from "./core/token.interceptor";
import { MessageBroadcasterService } from "./services/message.service";
import { ChatService } from "./pages/chat/chat.service";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ToastService } from "./core/toast.service";
import { Helpers } from "./services/app.helpers";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { FileUploadService } from "./core/file-upload.service";
import { environment } from "src/environments/environment";
import { ToastModule } from "primeng/toast";

import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { AuthResolver } from "./auth.resolver";
import { MessageService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { NotificationsService } from "./pages/notifications/notifications.service";
import { CommunityLayoutComponent } from "./pages/communities/community/community-layout/community-layout.component";
import { ShareButtonsModule } from '@ngx-share/buttons';

const config: SocketIoConfig = {
  url: environment.sockets.url,
  options: {
    path: environment.sockets.path,
    transports: environment.sockets.transports,
  },
}; 
//const config: SocketIoConfig = { url: environment.socketsPath, options: {} };

const modules = [ThemeModule];

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/translations/");
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [AppComponent, CommunityLayoutComponent],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    LoadingBarHttpClientModule,
    FormsModule,
    NgbModule,
    ToastModule,
    ConfirmDialogModule,
    PerfectScrollbarModule,
    SocketIoModule.forRoot(config),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ShareButtonsModule,
    ...modules,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    AuthenticationService,
    LoggerService,
    MessageBroadcasterService,
    MessageService,
    ToastService,
    ChatService,
    FileUploadService,
    ConfirmationService,
    NotificationsService,
    Helpers,
    AuthResolver,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
